<template>
  <v-row class="fill-height" justify="center" align="start">
    <v-col cols="12">
      <div class="d-flex justify-space-between py-5">
        <div class="d-flex cursor-pointer" @click="$router.go(-1)">
          <v-icon>mdi-chevron-left</v-icon>
          <div class="ml-2">Back</div>
        </div>
        <div>
          <span>New to Homify?</span>
          <span
            class="text-decoration-underline secondary--text ml-2 cursor-pointer"
            @click="goToPage('auth.register')"
          >Sign Up</span>
        </div>
      </div>
    </v-col>
    <v-col cols="11" md="8">
      <div>
        <p class="text-h4 font-weight-bold">
          Reset Password for your
          <span
            class="secondary--text text-h4 font-weight-bold homify-title"
          >Homify</span>
          Account
        </p>
        <p class="mb-6">
          A magic link would be sent to your mail to help reset your
          password.
        </p>
        <v-divider />

        <div class="mb-2 mt-10">Email Address*</div>
        <v-text-field
          :rules="[rules.required, rules.email]"
          v-model="form.email"
          placeholder="Enter email Address"
          outlined
        ></v-text-field>

        <small v-if="isLinkSent" class="primary--text">
          A magic link has been sent to your mail to help reset your
          password.
        </small>

        <v-btn
          block
          :loading="isLoading"
          depressed
          color="primary"
          :disabled="isDisabled"
          class="py-7 mt-10 text-none"
          @click="resetPassword"
        >Reset Password</v-btn>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { AuthService } from "@/services/index.js";

export default {
  data() {
    return {
      rememberMeCheckbox: false,
      isLoading: false,
      isLinkSent: false,
      form: {
        email: "",
      },
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
    };
  },
  computed: {
    ...mapState(["userObj"]),
    isDisabled() {
      return this.form.email.length == 0;
    },
  },
  methods: {
    ...mapActions("auth", ["forgotPassword"]),
    goToPage(name) {
      this.$router.push({ name });
    },
    async resetPassword() {
      try {
        this.isLoading = true;
        const { message } = await AuthService.forgotPassword(this.form.email);
        this.$store.commit("openSnackbar", 
          message
        );
        // await this.forgotPassword(this.form.email);

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        // throw error;
      }
    },
  },
};
</script>
